import React from 'react'
import '../Deletepoup/DeletepoupStyle.css'
import './CallScheduleStyle.css'

const CallSchedule = ({ isActive, setIsActive }) => {
    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>
            <div className="popupContainer deleteIconpoup">

                <div className="popupBody mb-30 CallSchedulepoup">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={() => setIsActive(false)} />
                    </span>
                    <div className="headingpoup flex-col">
                        <h3 className='mb-20'>Call Details</h3>
                        <div className="DateCllDspoup">
                            <span className='text2'>27 Feb, 2023</span> - <span className='text2'>11:00 AM</span>
                        </div>
                    </div>

                    <div className="contentWrapperCallSch">
                        <h3>Mentee</h3>
                        <p>Arvind Jha</p>
                    </div>
                    <div className="contentWrapperCallSch mt20">
                        <h3>Mentoring On</h3>
                        <p>Finance & Accounting</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default CallSchedule